import { createRouter, createWebHashHistory, createWebHistory  } from 'vue-router'


const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('@/views/MainPage/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage/index.vue')
  },
]

const router = createRouter({
  //history: createWebHashHistory('/'),
  history: createWebHistory(process.env.BASE_URL), // follows publicPath in vue.config.js automatically (staging & production)
  routes
})

export default router
